import { render, staticRenderFns } from "./VibrationBox.vue?vue&type=template&id=07a71066&scoped=true"
import script from "./VibrationBox.vue?vue&type=script&lang=js"
export * from "./VibrationBox.vue?vue&type=script&lang=js"
import style0 from "./VibrationBox.vue?vue&type=style&index=0&id=07a71066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a71066",
  null
  
)

export default component.exports